import httpClient from '@/lib/httpClient.js'
import { useQuery } from '@tanstack/react-query'

export default function useGetVault({ vaultId } = {}) {
  const fetchData = async () => {
    const response = await httpClient.get(`team/vault/${vaultId}`)
    return { ...response.data.data, entity_type: 'vault' }
  }

  return useQuery({
    queryKey: ['vaults', 'detail', vaultId],
    queryFn: fetchData,
    enabled: !!vaultId,
    staleTime: Infinity,
  })
}
